import { render, staticRenderFns } from "./VulDis.vue?vue&type=template&id=5dc27a34&scoped=true&"
import script from "./VulDis.vue?vue&type=script&lang=js&"
export * from "./VulDis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc27a34",
  null
  
)

export default component.exports